import { defaultZone, offsetToZone } from '../../time_helpers';

export default class TimePicker {
  constructor(time, zone, onChange) {
    this.onChange = onChange;
    this.$el = $('<div class="row row-cols-lg-auto gx-3 align-items-center time-picker">');
    this.el = this.$el[0];
    this.addTime(time);
    this.addZone(zone || defaultZone());
    this.$el.on('change', this.onChange);
  }

  destroy() {
    this.$el.remove();
    this.$el.off('change', this.onChange);
  }

  addTime(time) {
    const col = $('<div class="col">');
    col.appendTo(this.$el);

    this.$timeSelect = $('<select class="form-select">').appendTo(col);

    let hour;
    let minutes;

    if (time) {
      [hour, minutes] = time.split(':');
    }

    for (let i = 0; i <= 23; i += 1) {
      const t24 = `${i}:00`;

      let h = i;
      let meridiem = 'AM';
      if (i === 0 || i === 12) {
        h = 12;
      } else {
        h = i % 12;
      }

      if (i >= 12) {
        meridiem = 'PM';
      }

      this.$timeSelect.append(
        $('<option>', { value: t24, text: `${t24} (${h}:00 ${meridiem})` }),
      );

      if (time && parseInt(hour, 10) - i === 0) {
        if (time !== t24) {
          this.$timeSelect.append(
            $('<option>', {
              value: time,
              text: `${time} (${h}:${minutes} ${meridiem})`,
            }),
          );
        }
        this.$timeSelect.val(time);
      }
    }
  }

  addZone(zone) {
    const col = $('<div class="col">');
    col.appendTo(this.$el);

    this.$zoneSelect = $('<select class="form-select">').appendTo(col);

    for (let offset = -12; offset <= 14; offset += 1) {
      const z = offsetToZone(offset);
      this.$zoneSelect.append($('<option>', { value: z, text: z }));
    }

    this.$zoneSelect.on('change', () => this.saveZone());
    if (zone) {
      this.$zoneSelect.val(zone);
    }
  }

  saveZone() {
    $.cookie('search-timezone', this.zone(), {
      expires: 365,
      path: '/',
    });
  }

  time() {
    return this.$timeSelect.val();
  }

  zone() {
    return this.$zoneSelect.val();
  }

  hide() {
    this.$el.hide();
  }

  show() {
    this.$el.show();
  }
}
